export default {
  title: "Microlearnings",
};
